import axios from 'axios'
import env from "../../env"
import Swal from 'sweetalert2'

export const loginUser = payload => {
  return (dispatch, getState) => {
      axios({
        method:'post',
        url: `${env.REACT_APP_BE_URL}/login`,
        data: payload
      })
      .then(response => {
        localStorage.setItem("access_token", response.data.access_token)
        localStorage.setItem("user", response.data.user._id)
        dispatch({
            type: "SET_AUTHENTICATE",
            payload: true
        })
      })
      .catch(error => {
        dispatch({
          type: "SET_ERROR",
          payload: error
      })
    })
  }
};

export const registerUser = payload => {
  return (dispatch, getState) => {
    axios({
      method:'post',
      url: `${env.REACT_APP_BE_URL}/register`,
      data: payload
    })
    .then(response => {
      console.log(response);
      Swal.fire(
        'Registered!',
        'You can go to login page now.',
        'success'
      )
    })
    .catch(error => {
      console.log(error);
    })
  }
};

export const loginTest = payload => {
  return (dispatch, getState) => {
    localStorage.setItem("access_token", '123456')
    localStorage.setItem("user", 'admin')
    dispatch({
        type: "SET_AUTHENTICATE",
        payload: true
    })
  }
};


export const loginRegisterUser = payload => {
  const regexEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  const regexPhone = /(\+62 ((\d{3}([ -]\d{3,})([- ]\d{4,})?)|(\d+)))|(\(\d+\) \d+)|\d{3}( \d+)+|(\d+[ -]\d+)|\d+/;
  let data;
  if (payload.user.match(regexEmail)) {
    data = { email: payload.user }
  } else if (payload.user.match(regexPhone)) {
    data = { phone: payload.user }
  } else {
    console.log('error popup')
  }
  return (dispatch, getState) => {
      axios({
        method:'post',
        url: `${env.REACT_APP_BE_URL}/loginRegister`,
        data
      })
      .then(response => {
        localStorage.setItem("access_token", response.data.access_token)
        localStorage.setItem("user", response.data.user)
        dispatch({
            type: "SET_AUTHENTICATE",
            payload: true
        })
      })
      .catch(error => {
        dispatch({
          type: "SET_ERROR",
          payload: error
      })
    })
  }
};


export const logoutUser = payload => {
  return (dispatch, getState) => {
    window.FB.getLoginStatus(function(response) {
      if (response?.status === 'connected') {
        window.FB.logout(_ => {return})
      }
    })
    localStorage.removeItem('access_token')
    localStorage.removeItem('user')
    dispatch({
      type: "SET_AUTHENTICATE",
      payload: false
    })  
  }
};

export const findUser = () => {  
  return (dispatch, getState) => {
      dispatch({ type: 'SET_LOADING', payload: true })
      dispatch({ type: 'SET_APPS', payload: []})
        axios({
          method:'get',
          url: `${env.REACT_APP_BE_URL}/user`,
          headers: {
            authorization: `Bearer ${localStorage.getItem('access_token')}`
          },
        })
          .then(response => {
            dispatch({ type: 'SET_USER', payload: response.data.user})
            dispatch({ type: 'SET_PACKAGE', payload: response.data.package})
            dispatch({ type: 'SET_SUBS', payload: response.data.subs})
          })
          .catch(error => {
            dispatch({ type: 'SET_ERROR', payload: error})
          })
          .finally(_ => {
            dispatch({ type: 'SET_LOADING', payload: false })
          })
    }
}

export const updateUser = (formData) => {  
  return (dispatch, getState) => {
      dispatch({ type: 'SET_LOADING', payload: true })
      dispatch({ type: 'SET_USER', payload: {}})
        axios({
          method:'post',
          url: `${env.REACT_APP_BE_URL}/user`,
          data: formData,
          headers: {
            authorization: `Bearer ${localStorage.getItem('access_token')}`,
            'Content-Type': 'multipart/form-data'
          }
        })
          .then(response => {
              dispatch({ type: 'SET_USER', payload: response.data})
          })
          .catch(error => {
            dispatch({ type: 'SET_ERROR', payload: error})
          })
          .finally(_ => {
            dispatch({ type: 'SET_LOADING', payload: false })
          })
    }
}

export const guestContactUs = (payload) => {  
  return (dispatch, getState) => {
        axios({
          method:'post',
          url: `${env.REACT_APP_BE_URL}/contactUs`,
          data: payload,
        })
          .then(response => {
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'Your data has been submitted',
              timer: 1500
            })
          })
          .catch(error => {
            console.log(error);
          })
    }
}

export const getNotif = () => {  
  return (dispatch, getState) => {
      dispatch({ type: 'SET_NOTIF', payload: []})
        axios({
          method:'get',
          url: `${env.REACT_APP_BE_URL}/notification/getAll`,
          headers: {
            authorization: `Bearer ${localStorage.getItem('access_token')}`
          },
        })
          .then(response => {
            dispatch({ type: 'SET_NOTIF', payload: response.data})
          })
          .catch(error => {
            dispatch({ type: 'SET_ERROR', payload: error})
          })
          .finally(_ => {
            // dispatch({ type: 'SET_LOADING', payload: false })
          })
    }
}

export const updateNotifStatus = () => {  
  return (dispatch, getState) => {
        axios({
          method:'put',
          url: `${env.REACT_APP_BE_URL}/notification/updateState`,
          headers: {
            authorization: `Bearer ${localStorage.getItem('access_token')}`
          },
        })
          .then(response => {
            console.log(response,'<<<');
          })
          .catch(error => {
          })
          .finally(_ => {
            // dispatch({ type: 'SET_LOADING', payload: false })
          })
    }
}

export const updateRecentStatus = () => {  
  return (dispatch, getState) => {
        axios({
          method:'put',
          url: `${env.REACT_APP_BE_URL}/notification/updateRecent`,
          headers: {
            authorization: `Bearer ${localStorage.getItem('access_token')}`
          },
        })
          .then(response => {
            console.log(response,'<<<');
          })
          .catch(error => {
          })
          .finally(_ => {
            // dispatch({ type: 'SET_LOADING', payload: false })
          })
    }
}

export const getContactUsList = () => {  
  return (dispatch, getState) => {
      dispatch({ type: 'SET_CONTACT_US', payload: []})
        axios({
          method:'get',
          url: `${env.REACT_APP_BE_URL}/admin/contactUs`,
          headers: {
            authorization: `Bearer ${localStorage.getItem('access_token')}`
          },
        })
          .then(response => {
            dispatch({ type: 'SET_CONTACT_US', payload: response.data})
          })
          .catch(error => {
            dispatch({ type: 'SET_ERROR', payload: error})
          })
          .finally(_ => {
            // dispatch({ type: 'SET_LOADING', payload: false })
          })
    }
}


export const fetchConfigWhatsappData = (payload) => {  
  return (dispatch, getState) => {
      dispatch({ type: 'SET_LOADING', payload: true })
      axios({
          method:'get',
          url: `${env.REACT_APP_BE_URL}/bc-whatsapp/configData`,
          headers: {
            authorization: `Bearer ${localStorage.getItem('access_token')}`
          },
          body: payload
        })
          .then(response => {
            dispatch({ type: 'SET_USER_CONFIG', payload: response.data})
          })
          .catch(error => {
            dispatch({ type: 'SET_ERROR', payload: error})
          })
          .finally(_ => {
            dispatch({ type: 'SET_LOADING', payload: false })
          })
    }
}

export const setUserGetPricingInfo = (data) => {  
  return (dispatch, getState) => {
      dispatch({ type: 'SET_LOADING', payload: true })
      axios({
          method:'post',
          url: `${env.REACT_APP_BE_URL}/pricing/contact`,
          data
        })
        .then(response => {
          console.log('Data submitted');
          // console.log(response.data);
        })
        .catch(error => {
          dispatch({ type: 'SET_ERROR', payload: error})
        })
        .finally(_ => {
          dispatch({ type: 'SET_LOADING', payload: false })
        })
    }
}